"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canDeleteAnalysis = void 0;
/**
 * Accounts shown the delete control on an analysis, by sign-in email. This
 * only decides who sees it: the backend authorizes the DELETE against its own
 * ADMIN_EMAILS list (production holds the same single address).
 */
const ANALYSIS_DELETER_EMAILS = new Set([
    'ak@getcredible.ai',
]);
/** Compared case-insensitively, as the backend does. */
const canDeleteAnalysis = (email) => {
    if (typeof email !== 'string')
        return false;
    return ANALYSIS_DELETER_EMAILS.has(email.trim().toLowerCase());
};
exports.canDeleteAnalysis = canDeleteAnalysis;
